import './RuleCard.scss'
import { Rule, SeverityType } from '../../pages/AlarmModulePage'
import { useTranslation } from 'react-i18next';

type RuleCardProps = {
    rule: Rule;
    onEdit?: (rule: Rule) => void;
    onDelete?: (rule: Rule) => void;
    isTablet: boolean;
};

const badgeColorClass = (severity: SeverityType) => {
    switch (severity) {
        case SeverityType.Critical: return 'badge-color-critical';
        case SeverityType.Warning: return 'badge-color-warning';
        case SeverityType.Minor: return 'badge-color-minor';
        default: return 'badge-color-warning';
    }
};

const RuleCard = ({ rule, onEdit, onDelete, isTablet }: RuleCardProps) => {
    const { t } = useTranslation();

    return (
        <div className="RuleCard rounded-1 py-2 px-3">
            <div className='d-flex justify-content-between align-items-center pb-2 '>
                <button onClick={() => onDelete?.(rule)} className='btn-Custom btn-IDRed buttonRadius'><i className="bi bi-trash"></i></button>
                <h4>{rule.name}</h4>
                <button onClick={() => onEdit?.(rule)} className='btn-Custom btn-IDGreen  buttonRadius'><i className="bi bi-pencil"></i></button>
            </div>
            <div className='d-flex flex-wrap gap-2 pt-2'>
                <h5><span className="badge bg-secondary">
                    {rule.param}
                </span></h5>
                {rule.min &&
                    <h5><span className="badge bg-secondary">
                        <i className="bi bi-arrow-down"></i>
                        {rule.min} {rule?.paramUnits}
                    </span></h5>}
                {rule.max &&
                    <h5><span className="badge bg-secondary">
                        <i className="bi bi-arrow-up"></i>
                        {rule.max} {rule?.paramUnits}
                    </span></h5>}
                {isTablet &&
                    <h5 className="invisible"><span className="badge bg-secondary">placeholder</span></h5>
                }
            </div>
            <div className='d-flex flex-column'>
                <span className="two-line-paragraph small">{rule.description}</span>

                <div className='d-flex align-items-end'>
                    <div className='d-flex'>
                        <h6 className='m-0'><span className={`badge ${rule.active ? 'badge-color-active' : 'badge-color-inactive'}`}>
                            {rule.active ? t('Active') : t('Inactive')}
                        </span></h6>
                        <h6 className='m-0'><span className={`badge ms-2 ${badgeColorClass(rule.severity)}`}>
                            {t('Severity' + SeverityType[rule.severity])}
                        </span></h6>
                    </div>
                    <h4 className='ms-auto mb-0'><i className="bi bi-envelope-at" style={{ color: rule.emails && rule.emails.length > 0 ? '#0B9729' : '#A8AAA8' }}></i></h4>
                </div>

            </div >
        </div>
    )

}

export default RuleCard